document.addEventListener('DOMContentLoaded', function () {
  if (document.querySelector('.persons-count')) {
    const personInput = document.querySelector('.persons-count')
    const personText = document.querySelector('.persons-count-text')
    const incrementBtn = document.querySelector('.increment-btn')
    const decrementBtn = document.querySelector('.decrement-btn')

    // Add shake animation and remove it after animation ends
    function shakeInput() {
      personInput.classList.add('animate-shake')
      setTimeout(() => {
        personInput.classList.remove('animate-shake')
      }, 300) // match the animation duration
    }

    function updatePersonText(newValue) {
      if (parseInt(newValue) === 1) {
        personText.textContent = 'osoba'
      } else if (parseInt(newValue) >= 5) {
        personText.textContent = 'osób'
      } else {
        personText.textContent = 'osoby'
      }
    }

    // Increment button click
    incrementBtn.addEventListener('click', function () {
      let currentValue = parseInt(personInput.value, 10)
      if (currentValue < 9) {
        const newValue = currentValue + 1
        updatePersonText(newValue)
        personInput.value = newValue
      } else {
        // Add shake animation when trying to exceed max value
        shakeInput()
      }
    })

    // Decrement button click
    decrementBtn.addEventListener('click', function () {
      let currentValue = parseInt(personInput.value, 10)
      if (currentValue > 1) {
        const newValue = currentValue - 1
        updatePersonText(newValue)
        personInput.value = newValue
      } else {
        // Add shake animation when trying to go below min value
        shakeInput()
      }
    })
  }
})
